export default "__VITE_ASSET__CaFQnssd__"